// Removes HTML tags from string
const stripHtml = (text) => {
    return text.replace(/<[^>]*>?/gm, '');
}

export {
    stripHtml
}